import qs from 'qs';

import { apiUrl } from '../envUtil';
import { APIRequest } from '../apiUtil';
import { Mixpanel } from 'utils/mixPanelUtil';

export type ReportScope = 'all' | 'breakdown' | 'agent';
export type TransactionCsvType = 'all' | 'buyer' | 'listing' | 'rental';

export const getSummaryData = (
    summaryType: string = 'by-transactions',
    date_start: string | undefined,
    date_end: string | undefined,
    browser_ts: number
) => {
    if (date_start) {
        Mixpanel.track('app.summary_custom_date', {
            date_start,
            date_end,
        });
    }

    const params: string = qs.stringify({
        date_start,
        date_end,
        browser_ts: browser_ts || Date.now(), // browser timestamp for filtering the transaction by date
    });

    return APIRequest({
        method: 'get',
        url: apiUrl + `summary/${summaryType}?` + params,
    });
};

export const downloadSummaryReportPDF = async (
    date_start: string | undefined,
    date_end: string | undefined,
    browser_ts: number,
    scope: ReportScope = 'all',
    agent_account_id?: number
): Promise<void> => {
    const params = new URLSearchParams();
    if (date_start) params.set('date_start', date_start);
    if (date_end) params.set('date_end', date_end);
    params.set('browser_ts', (browser_ts || Math.floor(Date.now() / 1000)).toString());
    params.set('scope', scope);
    if (agent_account_id) params.set('agent_account_id', agent_account_id.toString());

    const token = localStorage.getItem('jwt');

    const response = await fetch(`${apiUrl}summary/report/pdf?${params.toString()}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (response.status === 409) {
        throw new Error('REPORT_IN_PROGRESS');
    }

    if (!response.ok) {
        throw new Error('Failed to generate report');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `audit-summary-report-${date_start || 'all'}-to-${date_end || 'all'}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};

export const downloadTransactionsCSV = async (
    date_start: string,
    date_end: string,
    type: TransactionCsvType = 'all',
    scope: 'all' | 'agent' = 'all',
    agent_account_id?: number
): Promise<void> => {
    const params = new URLSearchParams();
    params.set('date_start', date_start);
    params.set('date_end', date_end);
    params.set('type', type);
    params.set('scope', scope);
    if (scope === 'agent' && agent_account_id) {
        params.set('agent_account_id', agent_account_id.toString());
    }

    const token = localStorage.getItem('jwt');

    const response = await fetch(`${apiUrl}summary/report/csv?${params.toString()}`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to generate CSV');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ezcoordinator-transactions_${date_start}_to_${date_end}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};
